import LeftMenu from './container';

export default LeftMenu;
